import { IsEmail, IsNotEmpty } from "class-validator";
import { PreferencesModel } from "@/app/users/modules/preferences/models/PreferencesModel";

export class SecurityModel {
  @IsEmail({}, { message: "invalid_email" })
  public email: string;

  @IsNotEmpty()
  public password: string;

  constructor(data: Partial<SecurityModel> = {}) {
    this.email = data.email ?? "";
    this.password = data.password ?? "";
  }
}

export class LoginModel {
  public accessToken: string;

  public refreshToken: string;

  public expiresInMs: number;

  public user: User;

  public tokenType: string;

  constructor(data: Partial<LoginModel> = {}) {
    this.accessToken = data.accessToken ?? "";
    this.refreshToken = data.refreshToken ?? "";
    this.expiresInMs = data.expiresInMs ?? null;
    this.user = data.user ? new User(data.user) : new User();
    this.tokenType = data.tokenType ?? "";
  }
}

export class User {
  public id: number;

  public name: string;

  public email: string;

  public principalRole: string;

  public preferences: PreferencesModel;

  public roles: string[];

  constructor(data: Partial<User> = {}) {
    this.id = data.id ?? null;
    this.name = data.name ?? "";
    this.email = data.email ?? "";
    this.principalRole = data.principalRole ?? "";
    this.preferences = data.preferences
      ? new PreferencesModel(data.preferences)
      : new PreferencesModel();
    this.roles = data.roles ?? [];
  }

  setPreferences(_preferences: PreferencesModel) {
    this.preferences = new PreferencesModel(_preferences);
  }
}
